import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import Notification from "../components/Notification";

const RfiActionToastContext = createContext(null);

/**
 * Toast for VQQ row actions (cancel, resend, archive, …). Lives above the data grid so it
 * stays visible when react-query refetch remounts row menus.
 */
export function RfiActionToastProvider({ children }) {
  const [toast, setToast] = useState({
    show: false,
    message: "",
    status: "success",
  });

  const showToast = useCallback(({ message, status = "success" }) => {
    setToast({ show: true, message, status });
  }, []);

  const setShow = useCallback((show) => {
    setToast((prev) => ({ ...prev, show }));
  }, []);

  const value = useMemo(() => ({ showToast }), [showToast]);

  return (
    <RfiActionToastContext.Provider value={value}>
      {children}
      <Notification
        show={toast.show}
        setShow={setShow}
        status={toast.status}
        errorMessage={toast.message}
      />
    </RfiActionToastContext.Provider>
  );
}

/** @returns {{ showToast: (opts: { message: string, status?: string }) => void } | null} */
export function useRfiActionToastOptional() {
  return useContext(RfiActionToastContext);
}
